import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../../services/localStorage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  private localStorageService = inject(LocalStorageService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    // Obtenir le rôle de l'utilisateur connecté
    const userRole = this.localStorageService.getRole();
    
    // Obtenir les rôles autorisés pour cette route
    const expectedRoles = route.data['roles'] as Array<string>;

    // Vérifier si le rôle est autorisé pour accéder à la page
    if (userRole && expectedRoles && expectedRoles.includes(userRole)) {
      return true; // Autorise l'accès
    }

    // Sinon, redirige vers une autre page (par exemple, une page d'erreur ou d'accueil)
    return this.router.createUrlTree(['/auth']);
  }
}
